export const PUSH_NOTIFICATION_PRIMER_SUPPRESSION_FOREVER = -1;
export const PUSH_NOTIFICATION_PRIMER_SUPPRESSION_MS = 14 * 24 * 60 * 60 * 1000; // 14 days
export const PUSH_NOTIFICATION_PRIMER_SUPPRESSION_STORAGE_KEY = 'sg-push-notification-permissions-primer-suppressed-until'; // prettier-ignore

export const LOCATION_PRIMER_SUPPRESSION_FOREVER = -1;
export const LOCATION_PRIMER_SUPPRESSION_MS = 14 * 24 * 60 * 60 * 1000; // 14 days
export const LOCATION_PRIMER_SUPPRESSION_STORAGE_KEY = 'sg-location-permissions-primer-suppressed-until'; // prettier-ignore
